export default __webpack_public_path__ + "static/media/icePatch.55696e33.mp3";